// MemeImage.js
import React from 'react';
import styled from 'styled-components';


const MemeImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;
`;

const MemeImageStyled = styled.img`
  border-radius: 45px;
  width: 600px;
  height: 800px;
  object-fit: cover;
  margin-top: 130px;
  margin-left: 500px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.4);
  }

  @media (max-width: 1200px) {
    width: 400px;
    height: 600px;
    margin-left: 250px;
  }

  @media (max-width: 768px) {
    width: 300px;
    height: 450px;
    margin-left: 0;
    margin-top: 60px;
  }
`;

const MemeImage = ({ src, alt, progressData }) => (
  <MemeImageContainer>
    {/* Imagem do meme */}
    <MemeImageStyled src={src} alt={alt} />
    {/* Barra de progresso horizontal */}
    
  </MemeImageContainer>
);

export default MemeImage;
